export const blockstar_test = {
    id: 55,
    name: 'BlockStar TEST',
    network: 'blockstar-test',
    nativeCurrency: {
      decimals: 18,
      name: 'BlockStar',
      symbol: 'TBST',
    },
    rpcUrls: {
      public: { http: ['https://testnet-rpc.blockstar.one'] },
      default: { http: ['https://testnet-rpc.blockstar.one'] },
    },
    blockExplorers: {
      etherscan: { name: 'BlockStarScan', url: 'https://testnet-scan.blockstar.one' },
      default: { name: 'BlockStarScan', url: 'https://testnet-scan.blockstar.one' },
    },
    contracts: {
      multicall3: {
        address: '0xDb7D3f15150BE34011b6E6BD48f75701B8A8A080',
        blockCreated: 12230,
      },
    },
}

export const blockstar = {
  id: 5512,
  name: 'BlockStar Mainnet',
  network: 'blockstar',
  nativeCurrency: {
    decimals: 18,
    name: 'BlockStar',
    symbol: 'BST',
  },
  rpcUrls: {
    public: { http: ['https://mainnet-rpc.blockstar.one'] },
    default: { http: ['https://mainnet-rpc.blockstar.one'] },
  },
  blockExplorers: {
    etherscan: { name: 'BlockStarScan', url: 'https://mainnet-scan.blockstar.one' },
    default: { name: 'BlockStarScan', url: 'https://mainnet-scan.blockstar.one' },
  },
  contracts: {
    multicall3: {
      address: '0x3c9d85F5C95E40C52980a8648397ca6E7cfA7932'
    },
  },
}


export const CHAIN_INFO = {
    // 55 : {
    //     name : "BlockStar TEST",
    //     rpc : "https://testnet-rpc.blockstar.one",
    //     chain_id : 55,
    //     symbol : "TBST",
    //     explorer : "https://testnet-scan.blockstar.one",
    //     multicall_address : "0xDb7D3f15150BE34011b6E6BD48f75701B8A8A080",
    //     stake_address : "0xD4Fa98b6858fd8ae4DedC66208cf07fA1695e9BE"
    // }
    5512 : {
        name : "BlockStar",
        rpc : "https://mainnet-rpc.blockstar.one",
        chain_id : 5512,
        symbol : "BST",
        explorer : "https://scan.blockstar.one",
        multicall_address : "0x3c9d85F5C95E40C52980a8648397ca6E7cfA7932",
        stake_address : "0x4E6e40F14fC1Ea5098DCaF020531551c142Da6C9"
    }
}


export const chains = [blockstar];
export const DEFAULT_CHAIN = 5512;
export const PROJECT_ID = '27b9720018bf7f8740936e6a6eb28604';

